import TaggingComponent from './TaggingComponent';

export default TaggingComponent;
